import { useEffect, useState } from "react";

export enum LocalStorageKeys {
  ANSWER_IDS = "COFFEE_ANSWER_IDS",
}

export const useLocalStorage = <T,>(
  key: string,
  initialValue: T
): [T, (value: T) => void] => {
  const getValue = () => {
    if (typeof window === "undefined") {
      return initialValue;
    }
    try {
      const item = window.localStorage.getItem(key);
      return item ? (JSON.parse(item) as T) : initialValue;
    } catch (error) {
      return initialValue;
    }
  };

  const [storedValue, setStoredValue] = useState<T>(getValue);

  const setValue = (value: T) => {
    try {
      setStoredValue(value);
      if (typeof window !== "undefined") {
        window.localStorage.setItem(key, JSON.stringify(value));
      }
    } catch (error) {
      console.error(`Failed to write to ${key} in localStorage`);
    }
  };

  useEffect(() => {
    setStoredValue(getValue());
  }, [key]);

  return [storedValue, setValue];
};
